export { default } from "./text-area";
